import { r } from 'config/routes'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { createPanelRoute } from 'views/panel/PanelLayout'

const TagsList = lazy(() => import('../List'))

export const tagsRoutes: RouteObject[] = [
  createPanelRoute({
    path: r['tag.list'],
    element: <TagsList />,
  }),
]
